module.exports = __webpack_public_path__ + "img/guiyang-109b87.png";